export const sectionTitleSpacingSx = {
  letterSpacing: "0.02em",
  wordSpacing: "0.12em",
};
